// extracted by mini-css-extract-plugin
export var arrows = "projects-module--arrows--5LooV";
export var arrow = "projects-module--arrow--i2YdA";